
import * as angular from "angular";
import {ILogService} from "angular";
import {IModalInstanceService} from "angular-ui-bootstrap";
import "./choose-application-time-range-modal.less";

class ChooseApplicationTimeRangeModalController {

    public modalInstance: IModalInstanceService;
    public resolve: any;
    public form: any;
    public showErrors: boolean = false;
    public selectedTimeRange: string = "";
    public currentYear: number = 0;

    /* @ngInject */
    constructor(private $log: ILogService) {
    }

    public $onInit() {
        this.$log.debug("ChooseApplicationTimeRangeModal initialized");
        this.currentYear = new Date().getFullYear();
    }

    public submit() {
        if (this.selectedTimeRange) {
            this.$log.debug("Selected time range:", this.selectedTimeRange);
            this.modalInstance.close({selectedTimeRange: this.selectedTimeRange});
        } else {
            this.showErrors = true;
        }
    }

    public cancel() {
        this.modalInstance.dismiss(false);
    }

}

export const ChooseApplicationTimeRangeModalComponent: angular.IComponentOptions = {
    bindings: {
        modalInstance: "<",
        resolve: "=",
    },
    controller: ChooseApplicationTimeRangeModalController,
    template: require("./choose-application-time-range-modal.html")
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/staff/dashboard/choose-application-time-range-modal.component.ts